<template>
    <div>
        <div class="table-layout">
            <el-table :height="500+'px'" :data="list" border style="width: 100%">
                <el-table-column prop="ts" label="时间" align="center" width="180"></el-table-column>
                <el-table-column prop="actRole" label="岗位/角色" align="left" width="180"></el-table-column>
                <el-table-column prop="actorName" label="操作人" align="left" width="120"></el-table-column>
                <el-table-column prop="action" label="操作" align="left" width="120"></el-table-column>
                <el-table-column prop="actDesc" label="操作描述" align="left"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import callBidApi from '../../api/callBid'

    export default {
        name: 'swb-call-bid-act-rec',
        desc: '招标书操作记录',
        props: ['docId'],
        data: function () {
            return {
                list: null
            }
        },
        created: function () {
            this.getList(this.docId);
        },
        methods: {
            getList: function (docId) {
                let self = this;
                let postData = {
                    docId: docId
                };
                callBidApi.getCallBidActRecByDocId(postData, function (result) {
                    if(result.type == 'info') {
                        self.list = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/callbid/CallBidActRecList.vue